<template>
  <div class="candidate-page">
    <title-menu
        :icon="'fad fa-users'"
        :id="'candidates'"
        :title="fullName"
    >
      <template slot="menu">
        <candidate-menu
            v-if="candidate"
            :activePage="candidatePage"
            :candidate="candidate"
            :hasAppAccount="candidateHasAppAccount"
            @setCandidatePage="setCandidatePage"
            @fase34Changed="toggleFase34"
        >
        </candidate-menu>
      </template>
    </title-menu>

    <div class="row m-reverse-xl">
      <div class="col mw-250">
        <div class="edit-nav-block m-hide-xl">
          <candidate-menu
              :activePage="candidatePage"
              :candidate="candidate"
              :hasAppAccount="candidateHasAppAccount"
              @setCandidatePage="setCandidatePage"
              @fase34Changed="toggleFase34"
          >
          </candidate-menu>
        </div>

        <edit-information
            v-if="candidate"
            :value="candidate"
            :placements="getCandidatePlacements(candidate.id)"
        >
        </edit-information>

        <div class="edit-upload-image upload-image-file" v-if="candidate">
          <div class="edit-upload-image upload-image-file" v-if="candidate" @click="triggerImageUpload">
            <label class="label-upload-image">
          <span class="wrap-upload-image">
              <span class="helper-img"></span>
               <template v-if="tempImage">
                <img
                    :src="tempImage" alt="Profile picture2">
              </template>
              <template v-if="profilePicture.file && !tempImage">
                <img
                    :src="profilePicture.url" alt="Profile picture3">
              </template>
          </span>
              <span class="edit-image-text">Bewerk foto</span>
            </label>
          </div>
          <div v-if="profilePicture.url || tempImage" class="rotate-photo-grid">
            <span class="edit-image-text rotate-button fas fa-undo" @click="rotateImage(-90)">
            </span>
            <span class="edit-image-text rotate-button fas fa-redo" @click="rotateImage(90)">
            </span>
          </div>
          <picture-input
              v-if="candidate"
              class="d-none"
              ref="pictureInput"
              :crop="false"
              accept="image/*"
              @change="handleProfileFileChange">
          </picture-input>
        </div>
      </div>
      <div class="col">
        <component
            :is="candidatePage"
            :candidateInfo="candidate"
            :availableUsers="availableUsers"
            :candidateId="candidate.id"
            :profilePicture="profilePicture"
            v-if="candidateLoaded"
            @candidateUpdated="setEditCandidate($event)"
            @unsavedChanges="hasUnsavedChanges($event)"
            @resetValue="resetValues($event)"
            @setCandidatePage="setCandidatePage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import titleMenu from '../../components/titleMenu';
import candidateMenu from '../../components/candidate/overview/candidateMenu';
import editInformation from '../../components/editInformation';
import candidateInformation from '../../components/candidate/overview/candidateInformation';
import candidateNotes from '../../components/candidate/overview/candidateNotes';
import candidateDocuments from '../../components/candidate/overview/candidateDocuments';
import candidateSickness from '../../components/candidate/overview/candidateSickness';
import candidatePlacings from '../../components/candidate/overview/candidatePlacingHistory';
import candidatePlace from '../../components/candidate/overview/candidatePlacing';
import candidateAppointment from '../../components/candidate/overview/candidateAppointment';
import candidateAppointments from '../../components/candidate/overview/candidateAppointmentHistory'
import candidatePoolOverview from '../../components/candidate/overview/candidatePoolOverview'

import {mapGetters} from 'vuex';
import mInput from '../../components/forms/mInput';
import mInputNumber from '../../components/forms/mInputNumber';
import SelectCertificate from '../../components/candidate/selectCertificate';
import LatestFunctions from '../../components/candidate/latestPositions';
import SelectEducation from '../../components/candidate/selectEducation';

import {candidateData} from '../../components/mixins/candidateData';
import {candidateMethods} from '../../components/mixins/candidateMethods';

import {swalModals} from '../../components/mixins/swalModals.js';
import {imageOrientation} from './../../components/mixins/imageOrientation.js';
import axios from 'axios';
import {rotateBase64} from '../../functions/rotateBase64'
import store from "@/store";
import Vue from "vue";
import {Can} from '../../../permission/ability.js';
import {RIGHTS} from '../roles/rights';
import {statusOf, wasDefinitelyRefused} from '@/utils/apiOutcome';

export default {
  mixins: [candidateData, candidateMethods, swalModals, imageOrientation],
  components: {
    titleMenu,
    candidateMenu,
    editInformation,
    candidateInformation,
    candidateNotes,
    candidateDocuments,
    candidateSickness,
    candidatePlacings,
    candidateAppointments,
    candidatePoolOverview,
    candidatePlace,
    candidateAppointment,
    mInput,
    mInputNumber,
    SelectEducation,
    SelectCertificate,
    LatestFunctions
  },
  props: ['id'],
  data() {
    return {
      showHide: false,
      availableUsers:[],
      disableNavigation: false,
      candidateLoaded: false,
      candidatePage: 'candidateNotes',
      renderedComponent: true,
      candidate: null,
      candidateHasAppAccount: false,
      tempImage: null,
      profilePicture: {
        profilePicture: true,
        name: 'profilepicture',
        file: null,
        url: null
      }
    };
  },
  methods: {
    async lookUpAppAccount() {
      if (!Can(RIGHTS.CHAT_VIEW)) {
        return;
      }

      const lookupStatus = statusOf(await store.dispatch('chats/findFlexworkerByCandidateId', {
        ApiClient: Vue.prototype.$ApiClient,
        candidateId: this.id
      }));
      const chatRuledOut = wasDefinitelyRefused(lookupStatus);

      this.candidateHasAppAccount = !chatRuledOut;
    },
    async rotateImage(degrees) {
      if (typeof this.profilePicture.file === 'string') {
        const file = await axios.get(this.profilePicture.url, {responseType: 'blob'});
        this.profilePicture.file = file.data;
      }
      var reader = new FileReader();
      reader.readAsDataURL(this.profilePicture.file);
      reader.onload = () => {
        const base64 = reader.result;
        rotateBase64(base64, degrees, (rotatedImg) => {
          this.profilePicture.file = this.dataURItoBlob(rotatedImg);
          this.tempImage = rotatedImg;
          this.profilePicture.path = '/candidates/' + this.id + '/';
          delete this.profilePicture.metaData;
          this.$FB_UPLOADER.upload(this.profilePicture).then(() => {
            this.$toasted.global.successRequest({
              message: 'Afbeelding geroteerd'
            });
            this.$store.commit('setLoading', false);
          }).catch(() => {
            this.$toasted.global.failedRequest();
          });
        });
      }
    },
    triggerImageUpload() {
      this.$refs.pictureInput.$refs.fileInput.click();
    },
    handleProfileFileChange() {
      this.$store.commit('setLoading', true);
      this.profilePicture.file = this.$refs.pictureInput.file;

      let file = this.profilePicture.file;

      let ImgCheck = this.$refs.pictureInput;

      ImgCheck.getEXIFOrientation(file, (orientation) => {

            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
              var base64 = reader.result;
              this.resetOrientation(base64, orientation, (resetBase64Image) => {

                this.profilePicture.file = this.dataURItoBlob(resetBase64Image);
                this.tempImage = resetBase64Image;
                this.profilePicture.path = '/candidates/' + this.id + '/';
                delete this.profilePicture.metaData;

                this.$FB_UPLOADER.upload(this.profilePicture).then(() => {
                  this.$store.commit('setLoading', false);
                }).catch(() => {
                  this.$toasted.global.failedRequest();
                });
              });
            };
          }
      );
    },
    hasUnsavedChanges(event) {
      this.disableNavigation = event;
    },
    resetValues(value) {
      this.candidate = value;
    },
    toggleFase34() {
      this.$set(this.candidate, 'fase34', !this.candidate.fase34);
      this.$store.dispatch('candidates/patch', { id: this.candidate.id, fase34: this.candidate.fase34 });
    },
    setCandidatePage(page) {
      if (this.disableNavigation) {
        this.swalUnsavedChanges().then(result => {
          if (result.value) {
            this.candidatePage = page;
            this.disableNavigation = false;
          }
        });
      } else {
        this.candidatePage = page;
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.disableNavigation) {
      this.swalUnsavedChanges().then(result => {
        if (result.value) {
          next();
          this.candidate = this.candidateCopy;
        }
      });
    } else {
      next();
    }
  },
  computed: {
    ...mapGetters('candidates',
        ['getCandidates']),
    ...mapGetters('placements',
        ['getCandidatePlacements']),
    fullName() {
      if (!this.candidate) return '';
      return this.candidate.firstName + ' ' + this.candidate.lastName;
    }
  },
  watch: {
    'candidate.birthdate': function (val) {
      this.candidate.age = Math.floor(moment.duration(moment().diff(val)).asYears());
    }
  },
  created() {
    this.lookUpAppAccount();

    let id = this.id;
    let self = this;
    let ref = this.$FB_STORAGE.ref('');
    let documentList = ref.child('candidates/' + id);
    try {
      documentList.listAll().then(function (itemList) {
        itemList.items.forEach(function (itemRef) {
          itemRef.getDownloadURL().then((documentUrl) => {
            itemRef.getMetadata().then(meta => {
              if (meta.customMetadata.profilePicture) {
                self.profilePicture = {
                  profilePicture: true,
                  name: 'profilepicture',
                  file: documentUrl,
                  url: documentUrl,
                  metaData: meta.customMetadata
                };
              }
            });
          });
        });
      }).catch(function (error) {
        console.log(error);
      });
    } catch (e) {
      console.error('No profile pic', e)
    }

    this.$store.dispatch('candidates/fetchById', id).then(res => {
      this.candidate = Object.assign({}, res);
      this.candidateLoaded = true;
      if (this.$route.path.match(/^\/.*\/appointment$/)) {
        this.setCandidatePage('candidateAppointment');
      }
    });
  }
};
</script>

<style lang="scss">
.rotate-button {
  padding-top: 1rem;
}

.rotate-photo-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  background-color: white;
}
</style>